<div
  id="overlay"
  class="overlay"
  *ngIf="isVisible"
  (click)="onBackdropClick($event)"
>
  <div
    class="deals-panel"
    role="dialog"
    aria-modal="true"
    aria-labelledby="deals-title"
  >
    <button class="close-btn" (click)="closeModal()" aria-label="Close">
      &times;
    </button>
    <div id="deals-title" class="deals-title" role="heading" aria-level="2">
      Sign Up for Our Exclusive Deals
    </div>

    <form [formGroup]="signupForm" (ngSubmit)="subscribe()">
      <div class="form-group">
        <label for="deals-name">Name <span class="required">*</span></label>
        <input
          type="text"
          id="deals-name"
          formControlName="name"
          class="form-control"
          placeholder="Name"
        />
        <div class="field-error" *ngIf="isFieldInvalid('name')">
          Please enter your name.
        </div>
      </div>

      <div class="form-group">
        <label for="deals-email"
          >Email address <span class="required">*</span></label
        >
        <input
          type="email"
          id="deals-email"
          formControlName="email"
          class="form-control"
          placeholder="Email address"
        />
        <div class="field-error" *ngIf="isFieldInvalid('email')">
          Please enter a valid email address.
        </div>
      </div>

      <div class="field-error" *ngIf="showError">
        We could not sign you up. Please try again.
      </div>

      <button
        type="submit"
        class="submit-button"
        [ngClass]="!signupForm.valid || isSubmitting ? 'disabled' : ''"
        [disabled]="!signupForm.valid || isSubmitting"
      >
        {{ isSubmitting ? "Submitting..." : "Subscribe" }}
      </button>
    </form>

    <p class="form-note">
      We will keep your personal details secure and use the information you
      provide consistently with applicable privacy and data protection laws and
      the terms of our
      <a routerLink="/privacy-policy" (click)="closeModal()">Privacy Policy</a>
    </p>

    <div class="chat-block">
      <span class="chat-sep">or</span>
      <button type="button" class="cta-button" (click)="openChat()">
        Chat to a Member of Our Team
      </button>
    </div>
  </div>
</div>

<app-submited-modal
  [isOpen]="isSubmitedOpen"
  [title]="submitedTitle"
  [message]="submitedMessage"
  (close)="closeSubmited()"
></app-submited-modal>
